import { render, staticRenderFns } from "./cleaning.vue?vue&type=template&id=610678d1&scoped=true&lang=pug&"
import script from "./cleaning.vue?vue&type=script&setup=true&lang=js&"
export * from "./cleaning.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./cleaning.vue?vue&type=style&index=0&id=610678d1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610678d1",
  null
  
)

export default component.exports